// components/Statement.js
import React, { useState, useEffect } from "react";
import { AnimatedSwatchIcon } from "../content/icons/AnimatedSwatchIcon.tsx";
import { AnimatedPaletteIcon } from "../content/icons/AnimatedPaletteIcon.tsx";

function useIconSize() {
  const [iconSize, setIconSize] = useState(40);

  useEffect(() => {
    const updateSize = () => {
      setIconSize(window.innerWidth <= 740 ? 24 : 40);
    };

    // Set initial size
    updateSize();

    // Add event listener
    window.addEventListener('resize', updateSize);

    // Cleanup
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return iconSize;
}

function Statement() {
  const iconSize = useIconSize();

  return (
    <div className="statement-section">
      <p className="statement-text">
        Abby is a designer with a strong sense of craft and a head for strategy. 
        <AnimatedSwatchIcon size={iconSize}/>
        She's happiest when she's making things. 
        <AnimatedPaletteIcon size={iconSize}/>
      </p>
    </div>
  );
}

export default Statement;